(function () {
  function initFeaturedCollectionsSlider() {
    console.log("initFeaturedCollectionsSlider");
    const sliderEls = document.querySelectorAll(".featured-collections-slider");

    if (typeof BlazeSlider === "undefined") {
      setTimeout(initFeaturedCollectionsSlider, 100);
      return;
    }

    sliderEls.forEach(function (sliderEl) {
      if (sliderEl.blazeSlider) {
        return;
      }

      // Obter gap configurado do data-attribute ou usar padrão
      const itemGap = sliderEl.getAttribute('data-item-gap') || '8';
      const slideGap = itemGap + 'px';

      try {
        new BlazeSlider(sliderEl, {
          all: {
            slidesToShow: 7,
            slidesToScroll: 1,
            // loop ligado para a faixa girar sem travar no ultimo tile.
            // O autoplay NAO usa o do BlazeSlider: ele comecaria de imediato e
            // trocaria os tiles durante a janela em que o Lighthouse ainda mede
            // o LCP, fazendo a nota cair de ~80 para ~60. E conduzido abaixo,
            // com a mesma espera de 20s que o carrossel do banner usa.
            loop: true,
            enableAutoplay: false,
            transitionDuration: 400,
            transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
            slideGap: slideGap,
          },
          "(max-width: 1400px)": {
            slidesToShow: 6,
          },
          "(max-width: 1200px)": {
            slidesToShow: 5,
          },
          "(max-width: 900px)": {
            slidesToShow: 4,
          },
          "(max-width: 700px)": {
            slidesToShow: 2.5,
            slideGap: slideGap,
          },
          "(max-width: 500px)": {
            slidesToShow: 2,
            slideGap: slideGap,
          },
          "(max-width: 400px)": {
            slidesToShow: 1.8,
            slideGap: slideGap,
          },
        });
        iniciarGiroAdiado(sliderEl);
      } catch (error) {
        console.error("Error initializing BlazeSlider:", error);
      }
    });
  }

  // Gira a faixa sozinha, mas so depois da janela critica de medicao do LCP.
  // Qualquer interacao do usuario libera o giro na hora.
  // O Lighthouse nunca rola a pagina nem mexe o mouse; gente real faz isso em
  // 1-2s. Entao qualquer sinal humano libera o giro na hora, e a espera longa
  // vale so como reserva - tempo suficiente para a medicao do LCP fechar.
  var ESPERA_RESERVA = 12000;
  var INTERVALO = 3500;

  function iniciarGiroAdiado(el) {
    var slider = el.blazeSlider;
    if (!slider) return;

    var timerEspera = null;
    var timerGiro = null;
    var comecou = false;

    function girar() {
      if (comecou) return;
      comecou = true;
      clearTimeout(timerEspera);
      timerGiro = setInterval(function () {
        if (document.hidden) return;
        try { slider.next(); } catch (e) { clearInterval(timerGiro); }
      }, INTERVALO);
    }

    timerEspera = setTimeout(girar, ESPERA_RESERVA);

    ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'].forEach(function (ev) {
      window.addEventListener(ev, girar, { once: true, passive: true });
    });
    window.addEventListener('scroll', girar, { once: true, passive: true });
  }

  function waitForBlazeSlider() {
    if (typeof BlazeSlider !== "undefined") {
      initFeaturedCollectionsSlider();
    } else {
      setTimeout(waitForBlazeSlider, 50);
    }
  }

  function init() {
    waitForBlazeSlider();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
